import { CacheStrategy } from '@rammetec/data-access';
import { AUDIT_FIELD_DESCRIPTORS, AUDIT_FOREIGN_KEYS } from './_auditFields.js';
import { LIFECYCLE_FIELD_DESCRIPTORS } from './_lifecycleFields.js';
import { BUSINESS_ALLOWED_DATA_SOURCES, BUSINESS_DEFAULT_DATA_SOURCE } from './dataSourcePolicy.js';
import { VARIATION_OPTION } from '../types/variation-option.js';
import { FIELD_LIMITS } from '../validation/fieldLimits.js';
/**
 * Descriptor for VariationOption (Opção de variação).
 * Stored in 'org/{orgId}/variation-option'.
 */
export const variationOptionDescriptor = {
    name: VARIATION_OPTION,
    label: 'Opção de variação',
    domain: 'catalog',
    collectionPath: 'org/{orgId}/variation-option',
    pathPatternKeys: {
        orgId: 'string',
    },
    version: 1,
    description: 'Opções simples de variação de produto para o eixo OPTION (ex: impermeabilização, antifúngico)',
    repositoryConfig: {
        dataSource: BUSINESS_DEFAULT_DATA_SOURCE,
        cache: CacheStrategy.InMemory,
    },
    allowedDataSources: BUSINESS_ALLOWED_DATA_SOURCES,
    fields: [
        {
            name: 'id',
            label: 'ID',
            type: 'string',
            required: true,
            description: 'Unique variation option identifier',
        },
        {
            name: 'description',
            example: 'Acabamento padrão',
            label: 'Descrição',
            type: 'string',
            required: true,
            maxLength: FIELD_LIMITS.NAME,
            description: 'Variation option description',
        },
        ...LIFECYCLE_FIELD_DESCRIPTORS,
        ...AUDIT_FIELD_DESCRIPTORS,
    ],
    foreignKeys: [...AUDIT_FOREIGN_KEYS],
};
//# sourceMappingURL=variation-option.descriptor.js.map